import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i_upload",
  "use": "icon-i_upload-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-i_upload\"><title>icon_画板</title><path d=\"M9.06,14.65a1.14,1.14,0,0,1-.78-2l8-7.44a1.14,1.14,0,0,1,1.56,0l7.94,7.42a1.14,1.14,0,0,1,.06,1.61,1.15,1.15,0,0,1-1.62.06L17,7.64,9.84,14.35A1.16,1.16,0,0,1,9.06,14.65Z\" /><path d=\"M17,22.24a1.14,1.14,0,0,1-1.14-1.14v-15a1.14,1.14,0,0,1,2.28,0v15A1.14,1.14,0,0,1,17,22.24Z\" /><path d=\"M26.41,29.09H7.61a1.15,1.15,0,0,1,0-2.29h18.8a1.15,1.15,0,0,1,0,2.29Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol